export const TableHeader = (t) => [
  {
    title: t("labels.country.exchangeList.exchangeTable.headers.country"),
    field: "country_name",
    editable : "never"
  },
  {
    title: t("labels.country.exchangeList.exchangeTable.headers.exchangeCode"),
    field: "exchange_code",
  },
  {
    title: t("labels.country.exchangeList.exchangeTable.headers.exchangeName"),
    field: "exchange_name",
  },
  {
    title: t("labels.country.exchangeList.exchangeTable.headers.equivalent"),
    field: "is_equivalent",
    lookup: { true: t('labels.common.yes'), false: t('labels.common.no') },
  },
];
